import { render, staticRenderFns } from "./FormErrors.vue?vue&type=template&id=53242f8a&scoped=true&"
import script from "./FormErrors.vue?vue&type=script&lang=js&"
export * from "./FormErrors.vue?vue&type=script&lang=js&"
import style0 from "./FormErrors.vue?vue&type=style&index=0&id=53242f8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53242f8a",
  null
  
)

export default component.exports